import React from "react";

const SimpleFooter = () => {
  const footerLinks = window.post_template.checkout_v4_footer.footer_links;
  const isEnhancedContrast = window.enhancedContrast;
  const showDisclaimer = window.post_template.checkout_v4_footer.footer_show_disclaimer;
  const disclaimerText = window.post_template.checkout_v4_footer.tr_footer_disclaimer_text;

  return (
    <div className={`simpleFooter ${isEnhancedContrast && "enhancedContrast"}`}>
      <div className="simpleFooter_links">
        {Array.isArray(footerLinks) &&
          footerLinks.map((link, index) => {
            return (
              <a
                key={index}
                href={
                  !link.footer_link_type
                    ? link.footer_custom_link.footer_custom_link_href
                    : link.footer_post_link.footer_post_link_href
                }
                className={`${isEnhancedContrast && "enhancedContrast"}`}
              >
                {!link.footer_link_type
                  ? link.footer_custom_link.tr_footer_custom_link_label
                  : link.footer_post_link.tr_footer_post_link_label}
              </a>
            );
          })}
      </div>
      {showDisclaimer && <div className="disclaimerText">{disclaimerText}</div>}
    </div>
  );
};

export default SimpleFooter;
